"use client";

import ServiceAreaCardCustom from "../pages/use-case/service-area-card";
import { ICPServiceType1, UseCaseTechnical } from "@/types/global";

interface Props {
    title: string;
    description: string;
    data?: ICPServiceType1[] | UseCaseTechnical[];
}

const ServiceArea = ({ title, description, data }: Props) => {
    return (
        <section
            className="desilo-service2-section section-padding-top overflow-hidden"
            id="service-section"
        >
            <div className="container custom-container">
                <div className="row gx-4 gy-5 justify-content-between">
                    <div className="col-12 col-xl-6 col-xxl-5">
                        <div className="desilo__header text-center text-lg-start">
                            <h2 className="title">{title}</h2>
                            <p className="hero2-content-text">{description}</p>
                        </div>
                    </div>
                    <div className="col-12 col-xl-6 col-xxl-6">
                        <div className="row g-114 desilo-service2__row">
                            {data && data.map((item, i) => (
                                <ServiceAreaCardCustom
                                    key={i}
                                    data={item}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ServiceArea;
